module.exports = __webpack_public_path__ + "img/bgm-karewa.238e0e20.png";